import { useMemo, useRef } from 'react'
import { Box } from '@mui/material'

import KeyMetricComp from 'components/Reporting/Overview/GraphicalDetails/KeyMetricsSummary/KeyMetric'
import Card from 'components/Shared/Card'
import { KeyMetric } from 'types/KeyMetric'
import CardSkeleton from 'components/Shared/SkeletonStack/Card/CardSkeleton'
import { useAppSelector } from 'redux/Hook'

type Props = {
  isLoading: boolean
  keyMetrics: KeyMetric[]
}

interface MoreVertActionsProps {
  moreVertOptions: string[]
  moreVertRef: React.RefObject<HTMLDivElement>
  fileNameKey: string
}

const KeyMetricSummary = (props: Props) => {
  const {
    stakeholderDashboardDetails: { accessToken = '' },
  }: any = useAppSelector((state) => state)
  const { isLoading, keyMetrics = [] } = props || {}
  const memoisedKeyMetricsData = useMemo(() => {
    return Array.isArray(keyMetrics) ? keyMetrics : []
  }, [keyMetrics])
  // create key metrics ref
  const createMoreVertRef = useRef<HTMLDivElement>(
    null as unknown as HTMLDivElement,
  )

  const moreVertProps: MoreVertActionsProps = {
    moreVertOptions: ['jpeg', 'png', 'pdf', 'csv'],
    moreVertRef: createMoreVertRef,
    fileNameKey: 'keyMetrics',
  }

  const checkIfDataExists = () => {
    if (memoisedKeyMetricsData?.every((v) => v.value === 0)) return false

    return true
  }

  const buildKeyMetricsComponent = memoisedKeyMetricsData?.map(
    (metric: KeyMetric, index: number) => {
      return (
        <KeyMetricComp
          {...metric}
          showDivider={index + 1 < memoisedKeyMetricsData?.length}
          key={index}
        />
      )
    },
  )

  const buildSkeleton = (
    <CardSkeleton
      showHeaderSkeleton={true}
      sectionCount={4}
      height={28}
      borderType="bordered"
    />
  )

  const keyMetricsComponents = () => {
    const marginTop = accessToken ? -4.5 : -6.5
    return (
      <Box
        sx={{ marginTop: checkIfDataExists() ? marginTop : -4.5 }}
        id="key-metrics"
      >
        {isLoading ? buildSkeleton : buildKeyMetricsComponent}
      </Box>
    )
  }

  return (
    <Card
      moreVertProps={moreVertProps}
      isLoading={isLoading}
      content={keyMetricsComponents()}
      showMoreAction={checkIfDataExists() && !accessToken}
    />
  )
}

export default KeyMetricSummary
